module.exports = __webpack_public_path__ + "static/media/07-d-calendar.15d35aef.jpg";